import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import { IoChevronDownSharp } from 'react-icons/io5';
import styled from 'styled-components';
import { Fonts, Palette } from '../../../../../components/utils';

const ACCORDION_BORDER_COLOR = '#424856';

const AccordionContainer = styled.div`
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${ACCORDION_BORDER_COLOR};
  border-radius: 8px;
`;

const AccordionTopBar = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px;
  box-sizing: border-box;
  border: none;
  background: ${Palette.GHOST_WHITE};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
  font-family: inherit;
  text-align: left;
  border-bottom: none;
  border-radius: ${({ $isOpen }) => ($isOpen ? '7px 7px 0 0' : '7px')};

  &:focus {
    outline: none;
  }
`;

const AccordionTitleRow = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`;

const AccordionTitle = styled.span`
  color: ${Palette.BLACK};
  font-size: 18px;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-weight: 600;
  line-height: 24px;
`;

const AccordionChevronWrap = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
  transition: transform 0.2s ease;
`;

const AccordionContent = styled.div`
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  flex-direction: column;
  align-items: stretch;
  padding: 24px;
  box-sizing: border-box;
`;

function AmenityAccordion({
  title,
  defaultOpen = false,
  disabled = false,
  disabledTooltip,
  rightElement,
  children
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen && !disabled);

  useEffect(() => {
    if (disabled) {
      setIsOpen(false);
    }
  }, [disabled]);

  const handleToggle = () => {
    if (disabled) return;
    setIsOpen((prev) => !prev);
  };

  const topBar = (
    <AccordionTopBar
      type="button"
      $isOpen={isOpen}
      $disabled={disabled}
      onClick={handleToggle}
      aria-expanded={isOpen}
      aria-disabled={disabled}>
      <AccordionTitleRow>
        <AccordionTitle>{title}</AccordionTitle>
        {rightElement ?? null}
      </AccordionTitleRow>
      <AccordionChevronWrap $isOpen={isOpen} aria-hidden>
        <IoChevronDownSharp size={20} color={Palette.BLACK} />
      </AccordionChevronWrap>
    </AccordionTopBar>
  );

  return (
    <AccordionContainer>
      {disabled && disabledTooltip ? (
        <Tooltip title={disabledTooltip}>
          <span style={{ display: 'block' }}>{topBar}</span>
        </Tooltip>
      ) : (
        topBar
      )}
      <AccordionContent $isOpen={isOpen}>{children}</AccordionContent>
    </AccordionContainer>
  );
}

export default AmenityAccordion;
